const state = {
  namespaced: true,
  state: {
    showLimitDialog: false
  },
  mutations: {
    CHANGE_LIMIT_DIALOG(state, data){
      state.showLimitDialog = data
    } 
  },
  actions: {
    changeLimitDialog({commit}, payload) {
      console.log(12312, payload, 'store')
      commit('CHANGE_LIMIT_DIALOG', payload)
    }
  },
  modules: {
  },
  getters: {
    showLimitDialog: state => state.showLimitDialog
  }
};

export default state;
